import defaultSights from './default';

const defaultWithVin = {
  suv: [
    'sLu0CfOt', // Vin number
    ...defaultSights.suv,
  ],
  cuv: [
    'sLu0CfOt', // Vin number
    ...defaultSights.cuv,
  ],
  sedan: [
    'sLu0CfOt', // Vin number
    ...defaultSights.sedan,
  ],
  hatchback: [
    'sLu0CfOt', // Vin number
    ...defaultSights.hatchback,
  ],
  van: [
    'sLu0CfOt', // Vin number
    ...defaultSights.van,
  ],
  minivan: [
    'sLu0CfOt', // Vin number
    ...defaultSights.minivan,
  ],
  pickup: [
    'sLu0CfOt', // Vin number
    ...defaultSights.pickup,
  ],
};

export default defaultWithVin;
